const formatNumber = (value: number | string, decimals = 3): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return Number.isInteger(num) ? num.toString() : num.toFixed(decimals);
};

export default formatNumber;
